<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { ModalConfirmation } from '@shared/ui/modals'
import { NativeSelect } from '@shared/ui/fields'

import { useDisciplineModalDuplicate } from '../../model/discipline-modal-duplicate.hook'

defineOptions({
  name: 'ModalDisciplineDuplicate',
})

const {
  refIsOpen,
  refIsLoading,
  refTitle,
  refOptions,
  refCode,
  setCode,
  closeModal,
  confirmDuplicate,
} = useDisciplineModalDuplicate()
</script>

<template>
  <ModalConfirmation
    :show="refIsOpen"
    :loading="refIsLoading"
    :disabled="refIsLoading"
    mode="confirm"
    :title="refTitle"
    button-title="Duplicate"
    cancel-title="Close"
    is-close-icon
    @click:confirm="confirmDuplicate"
    @click:cancel="closeModal"
  >
    <template #content>
      <div class="modal-discipline-duplicate">
        <AppText
          name="body1"
          color="slate-700"
        >
          Are you sure you want to duplicate this discipline?
        </AppText>
        <NativeSelect
          name="discipline_code"
          label="Discipline"
          placeholder-enabled
          placeholder="Select here"
          :options="refOptions"
          :value="refCode"
          :disabled="refIsLoading"
          @change="setCode"
        />
      </div>
    </template>
  </ModalConfirmation>
</template>

<style scoped lang="scss" src="./ModalDisciplineDuplicate.scss" />
